import src from "IMAGE";
export default { src, width: 250, height: 175, blurWidth: 8, blurHeight: 6, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAARklEQVR42q3NOw6AIBBFUSJvZmJGY7QSglLyCftfH1SsgFuf5BqzpH2DKp0OEjI4JJK/WtxugsvyozhesE/gr5DENoBfs+8ehQLzeBTYcwAAAABJRU5ErkJggg=="};
